import _ from "lodash";

export const entity = {
    name: "Risk",
    fields: [
        "RiskType",
        {path: "code", unique: true},
        {path: "name"},
        {
            path: "translatedName",
            fieldPath: ["name"],
            $f: function (object, context, callback) {

                const translate = context?.translateName || (w => w)

                return callback(null, object.name && translate(object.name))
            }
        },
        {path: "description"},
        {
            path: "fullName",
            fieldPath: ['riskType.translatedName', 'translatedName'],
            f: function () {
                return `${this.riskType?.translatedName} - ${this.translatedName}`
            }
        }
    ],
    filters: [{
        name: "byRiskType",
        path: "riskType",
        object: "RiskType",
        display: "name",
        translateName: true,
        clearable: true,
        client: true,
        isDefault: false,
        query: function (context) {
            const riskTypeId = _.get(context.data, "riskType.id")
            return riskTypeId ? {riskType: new global.ObjectID(riskTypeId)} : {}
        }
    }]
}

export const module_ = {
    object: "Risk",
    tKey: "mTitle_risk",
    category: {
        path: "referential",
        icon: 'server'
    },
    defaultSortBy: "code",
    defaultSortDirection: "ASC",
    viewMap: {
        dt: [
            {path: "riskType", display: "codeName"},
            "code",
            {path: "name", translateName: true},
        ],
        form: [
            {path: "riskType", display: "codeName"},
            {path: "code"},
            {path: "name", type: "textarea"},
            {path: "description", type: "richTextEditor"},
        ]
    },
    filters: ["byRiskType"]
}
